// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import app from './AppData'
import TitleBarStore from '@/components/widgets/TitleBarStore'

import alert from '@/utils/VipAlert'

const ENV = require('@/env.js')

Vue.prototype.$alert = alert

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  console.log('beforeEach', to, from, app.isLogined())
  // alert('beforeEach')
  window.document.title = to.meta.title === undefined ? '智能接听助理' : to.meta.title
  TitleBarStore.store.setTitle(to.meta.title === undefined ? '智能接听助理' : to.meta.title)
  if (app.isLogined() || to.name === 'login' || ENV.MOCK) {
    next()
  } else {
    next({
      name: 'login',
      query: {
        redirect: to.fullPath
      }
    })
  }

  if (window.cancelVipWindow) {
    window.cancelVipWindow()
  }
})

function initJSBridge () {
  console.log('initJSBridge')
  return new Promise((resolve, reject) => {
    var initSuccess = function () {
      console.log('initSuccess')
      resolve()
    }
    doAsyn(initSuccess)
  })
}

function doAsyn (callback) {
  let callbackWrapper
  if (typeof TcsJSBridge === 'object' && typeof TcsJSBridge.invoke === 'function') {
    console.log('ready for: ' + callback)
    callback()
  } else {
    if (document.addEventListener) {
      callbackWrapper = function () {
        callback()
        document.removeEventListener('TcsJSBridgeReady', callbackWrapper)
      }
      console.log('not ready, addEventListener for: ' + callback)
      document.addEventListener('TcsJSBridgeReady', callbackWrapper, false)
    } else if (document.attachEvent) {
      callbackWrapper = function () {
        callback()
        document.detachEvent('TcsJSBridgeReady', callbackWrapper)
        document.detachEvent('onTcsJSBridgeReady', callbackWrapper)
      }
      console.log('not ready, attachEvent for: ' + callbackWrapper)
      document.attachEvent('TcsJSBridgeReady', callbackWrapper)
      document.attachEvent('onTcsJSBridgeReady', callbackWrapper)
    }
  }
}

async function init () {
  console.log('init')
  if (!ENV.MOCK) {
    await initJSBridge()
  }
  return new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
  })
}

init()
/* eslint-disable no-new */



// WEBPACK FOOTER //
// ./src/main.js